import { promisifySynchronousMethod } from '../utils/promisify-synchronous-method';
export class HTML5LocalStorage {
    storage;
    setSecureItem = this.setItem;
    getSecureItem = this.getItem;
    removeSecureItem = this.removeItem;
    getAllSecureKeys = this.getAllKeys;
    constructor(context) {
        this.storage = context.localStorage;
    }
    setItem(key, value) {
        // HTML5 local storage has no concept of null. A value is either a string or it
        // does not exist. If user tries to set null, it will end up as "null"
        // The solution in this case is to treat "null" as "remove if exists"
        // localStorage.getItem will correctly return null if a key is not present
        if (value === null) {
            this.storage.removeItem(key);
            return Promise.resolve();
        }
        return promisifySynchronousMethod(() => this.storage.setItem(key, value));
    }
    getItem(key) {
        return promisifySynchronousMethod(() => this.storage.getItem(key));
    }
    removeItem(key) {
        return promisifySynchronousMethod(() => this.storage.removeItem(key));
    }
    clear() {
        return promisifySynchronousMethod(() => this.storage.clear());
    }
    getAllKeys() {
        return promisifySynchronousMethod(() => Object.keys(this.storage));
    }
}
//# sourceMappingURL=html5-local-storage.js.map